// Navegación a una página de Conozcámonos desde otro módulo de la inscripción
// (p. ej. desde Sube tus documentos). La escucha page.tsx de initial-inscription.
export const MEET_US_STEP_NAME = 'Conozcámonos'
export const MEET_US_EDUCATION_PAGE = 4

const NAVIGATE_MEET_US_EVENT = 'navigate-meet-us-page'

export const navigateToMeetUsPage = (page: number): void => {
    window.dispatchEvent(
        new CustomEvent<number>(NAVIGATE_MEET_US_EVENT, { detail: page })
    )
}

export const onNavigateToMeetUsPage = (
    handler: (page: number) => void
): (() => void) => {
    const listener = (event: Event): void =>
        handler((event as CustomEvent<number>).detail)

    window.addEventListener(NAVIGATE_MEET_US_EVENT, listener)

    return () => window.removeEventListener(NAVIGATE_MEET_US_EVENT, listener)
}
